export default __webpack_public_path__ + "static/media/car_gray.b79eb87c.png";